// setup/setupInterceptors.ts
import apiClient from './apiClient';
import store from 'store';
import { LOGOUT_ACTION } from 'store/rootReducer';

export const setupInterceptors = () => {
    apiClient.interceptors.response.use(
        response => response,
        error => {
            if (error.response?.status === 401) {
                store.dispatch({ type: LOGOUT_ACTION });
            }
            return Promise.reject(error);
        }
    );
};